import {Op, NodeTypes, ConditionOperators} from '../../utils/ProjectTemplates'
import api from '../../api';

const state = {
  projectTemplates: [
    {
      id: 1,
      name: 'Tenders',
      rules: {
        type: NodeTypes.operation,
        key: Op.and,
        value: [
          {
            type: NodeTypes.condition,
            key: 'type',
            value: 'Tender',
            operator: ConditionOperators.equal
          },
          {
            type: NodeTypes.condition,
            key: 'categoryId',
            value: 9,
            operator: ConditionOperators.equal
          }
        ]
      },
      actionGroups: [
        {
          title: 'Project initiation',
          actions: [
            {
              title: 'Identify stakeholders',
              type: 'To-do',
            },
            {
              title: 'Project team formulated',
              type: 'Event',
            },
            {
              title: 'Kick off meeting',
              type: 'Meeting',
            },
            {
              title: 'Defining roles & agreeing objectives, timescales and scope',
              type: 'Milestone',
            },
          ],
        },
        {
          title: 'Research',
          actions: [
            {
              title: 'Market research conducted',
              type: 'To-do',
            },
            {
              title: 'Spend analysis – current total cost of ownership baseline',
              type: 'To-do',
            },
            {
              title: 'Supplier analysis',
              type: 'To-do',
            },
            {
              title: 'Produce RFI',
              type: 'To-do',
            },
            {
              title: 'Run RFI',
              type: 'Event',
            },
          ],
        },
      ]
    },
    {
      id: 2,
      name: 'Contract Renewals',
      rules: {
        type: NodeTypes.operation,
        key: Op.or,
        value: [
          {
            type: NodeTypes.operation,
            key: Op.and,
            value: [
              {
                type: NodeTypes.condition,
                key: 'type',
                value: 'Tender',
                operator: ConditionOperators.equal
              },
              {
                type: NodeTypes.condition,
                key: 'categoryId',
                value: 8,
                operator: ConditionOperators.equal
              }
            ]
          },
          {
            type: NodeTypes.operation,
            key: Op.and,
            value: [
              {
                type: NodeTypes.condition,
                key: 'type',
                value: 'Contract',
                operator: ConditionOperators.equal
              },
              {
                type: NodeTypes.condition,
                key: 'categoryId',
                value: 10,
                operator: ConditionOperators.equal
              }
            ]
          }
        ]
      },
      actionGroups: [
        {
          title: 'Project initiation',
          actions: [
            {
              title: 'Identify stakeholders',
              type: 'To-do',
            },
            {
              title: 'Project team formulated',
              type: 'Event',
            },
            {
              title: 'Kick off meeting',
              type: 'Meeting',
            },
            {
              title: 'Defining roles & agreeing objectives, timescales and scope',
              type: 'Milestone',
            },
          ],
        },
        {
          title: 'Research',
          actions: [
            {
              title: 'Market research conducted',
              type: 'To-do',
            },
            {
              title: 'Spend analysis – current total cost of ownership baseline',
              type: 'To-do',
            },
            {
              title: 'Supplier analysis',
              type: 'To-do',
            },
            {
              title: 'Produce RFI',
              type: 'To-do',
            },
            {
              title: 'Run RFI',
              type: 'Event',
            },
          ],
        },
      ]
    },
    {
      id: 3,
      name: 'Process Reviews',
      rules: {},
      actionGroups: [
        {
          title: 'Project initiation',
          actions: [
            {
              title: 'Identify stakeholders',
              type: 'To-do',
            },
            {
              title: 'Project team formulated',
              type: 'Event',
            },
            {
              title: 'Kick off meeting',
              type: 'Meeting',
            },
            {
              title: 'Defining roles & agreeing objectives, timescales and scope',
              type: 'Milestone',
            },
          ],
        },
        {
          title: 'Research',
          actions: [
            {
              title: 'Market research conducted',
              type: 'To-do',
            },
            {
              title: 'Spend analysis – current total cost of ownership baseline',
              type: 'To-do',
            },
            {
              title: 'Supplier analysis',
              type: 'To-do',
            },
            {
              title: 'Produce RFI',
              type: 'To-do',
            },
            {
              title: 'Run RFI',
              type: 'Event',
            },
          ],
        },
      ]
    }
  ],
};

const getters = {
  projectTemplates(state) {
    return state.projectTemplates;
  },
  projectTemplateById: (state, getters) => {
    return getters.projectTemplates.reduce((obj, template) => {
      obj[template.id] = {}
      Object.assign(obj[template.id], template)
      return obj
    }, {})
  }
};

const mutations = {
  setProjectTemplates(state, payload) {
    state.projectTemplates = payload;
  },
  upsertProjectTemplate(context, template) {
    const i = state.projectTemplates.findIndex((e) => e.id === template.id);
    if (i > -1) {
      Object.assign(state.projectTemplates[i], template);
    } else {
      state.projectTemplates.push(template);
    }
  },
};

const actions = {
  setProjectTemplates(context, payload) {
    context.commit('setProjectTemplates', payload);
  },
  getProjectTemplates(context) {
    return new Promise(async (resolve, reject) => {
      try {
        const {data} = await api.getProjectTemplates();
        await context.dispatch('setProjectTemplates', data.projectTemplates);
        resolve();
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  },
  createProjectTemplate(context, template) {
    return new Promise(async (resolve, reject) => {
      try {
        const {data} = await api.createProjectTemplate(template)
        context.commit('upsertProjectTemplate', data.createdProjectTemplate);
        resolve()
      } catch (e) {
        reject(e)
      }
    })
  },
  updateProjectTemplate(context, template) {
    return new Promise(async (resolve, reject) => {
      try {
        const {
          id,
          title,
          description,
          rules,
          actionGroups,
          notes} = template;
        const {data} = await api.updateProjectTemplate(id, {
          title,
          description,
          rules,
          actionGroups,
          notes
        })
        context.commit('upsertProjectTemplate', data.updatedProjectTemplate);
        resolve()
      } catch (e) {
        reject(e)
      }
    })
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
